import { Checkbox, CheckboxGroup, FormField } from "@hightouch/htui";
import type { FormatOption } from "src/pages/projects/library/files/export-formats";

/** One checkbox per export format, so a single download can include several. */
export function FormatCheckboxes<T extends string>({
  options,
  value,
  onChange,
}: {
  options: readonly FormatOption<T>[];
  value: ReadonlySet<T>;
  onChange: (value: Set<T>) => void;
}) {
  return (
    <FormField
      label="Format"
      error={value.size === 0 ? "Select at least one format." : undefined}
    >
      <CheckboxGroup>
        {options.map((option) => (
          <Checkbox
            key={option.value}
            label={option.label}
            description={option.description}
            isDisabled={option.isDisabled}
            isChecked={value.has(option.value)}
            onChange={(event) => {
              const next = new Set(value);
              if (event.target.checked) next.add(option.value);
              else next.delete(option.value);
              onChange(next);
            }}
          />
        ))}
      </CheckboxGroup>
    </FormField>
  );
}
